import { Trans, useTranslation } from "react-i18next";
import { useAppContext } from "@/hooks/use-app-context";
import { ReactNode } from "react";

export const useProfileTranslations = (section: string) => {
  const { t } = useTranslation();
  const { state } = useAppContext();

  const profileType = state.type || "my";

  return {
    tProfile: (key: string) => {
      return t(`${section}.${profileType}.${key}`);
    },

    tCommon: (key: string) => {
      return t(`${section}.common.${key}`);
    },

    TransProfile: ({
      keyName,
      components = {},
      values = {},
    }: {
      keyName: string;
      components?: Record<string, ReactNode>;
      values?: Record<string, any>;
    }) => {
      return (
        <Trans
          i18nKey={`${section}.${profileType}.${keyName}`}
          components={{
            strong: <strong />,
            br: <br />,
            span: <span />,
            u: <u />,
            ...components,
          }}
          values={values}
        />
      );
    },

    TransCommon: ({
      keyName,
      components = {},
      values = {},
    }: {
      keyName: string;
      components?: Record<string, ReactNode>;
      values?: Record<string, any>;
    }) => {
      return (
        <Trans
          i18nKey={`${section}.common.${keyName}`}
          components={{
            strong: <strong />,
            br: <br />,
            span: <span />,
            ...components,
          }}
          values={values}
        />
      );
    },

    profileType,

    t,
  };
};
